export default "__VITE_ASSET__0f1db762__"